const DATE_LOCALES = {
    tl: 'tl-ph',
    zh: 'zh-tw',
    no: 'nb',
    pt: 'pt-br',
};
const DEFAULT_DATE_FORMAT = 'MMM D';
const DATE_FORMATS = {
    ko: 'MMM D일',
    ja: 'MMMDo',
    vi: 'D MMMM',
};
const DEFAULT_FULL_DATE_FORMAT = 'll';
const FULL_DATE_FORMATS = {
    vi: 'D MMMM YYYY',
};
export const getDateLocale = (lng) => DATE_LOCALES[lng] || lng;
export const getDateFormat = (lng) => DATE_FORMATS[lng] || DEFAULT_DATE_FORMAT;
export const getFullDateFormat = (lng) => FULL_DATE_FORMATS[lng] || DEFAULT_FULL_DATE_FORMAT;
//# sourceMappingURL=time.js.map